import Vue from "vue";
import VueRouter from "vue-router";
import admin from "../views/admin/header.vue";

import MiddlewareStylesheet from "./middleware/stylesheet";

//前台網站設置區(中文)
import Home from "../views/default/Home.vue";
import Copyright from "../views/default/Copyright.vue";
import Sitemap from "../views/default/Sitemap.vue";
import News from "../views/default/News.vue";
import NewsAlbum from "../views/default/News_Image.vue";
import NewsVideo from "../views/default/News_Video.vue";
import About from "../views/default/About.vue";
import Member from "../views/default/Member.vue";
import Admissions from "../views/default/Admissions.vue";
import Curriculum from "../views/default/Curriculum.vue";
import Research from "../views/default/Research.vue";
import Forms from "../views/default/Forms.vue";
import Journal from "../views/default/Journal.vue";
import FAQ from "../views/default/FAQ.vue";
import Search from "../views/default/Search.vue";
import InServiceMaster from "../views/default/InServiceMaster.vue"

//前台網站設置區(英文)
import Home_en from "../views/default_en/Home.vue";
import Copyright_en from "../views/default_en/Copyright.vue";
import Sitemap_en from "../views/default_en/Sitemap.vue";
import News_en from "../views/default_en/News.vue";
import NewsAlbum_en from "../views/default_en/News_Image.vue";
import NewsVideo_en from "../views/default_en/News_Video.vue";
import About_en from "../views/default_en/About.vue";
import Member_en from "../views/default_en/Member.vue";
import Admissions_en from "../views/default_en/Admissions.vue";
import Curriculum_en from "../views/default_en/Curriculum.vue";
import Research_en from "../views/default_en/Research.vue";
import Forms_en from "../views/default_en/Forms.vue";
import Journal_en from "../views/default_en/Journal.vue";
import FAQ_en from "../views/default_en/FAQ.vue";
import Search_en from "../views/default_en/Search.vue";
import InServiceMaster_en from "../views/default_en/InServiceMaster.vue"

//後台網站設置區
import Admin_Login from "../views/admin/Login.vue";
import Admin_Home from "../views/admin/Home.vue";
import Admin_Account from "../views/admin/Account.vue";
import Admin_AccountGroup from "../views/admin/AccountGroup.vue";
import Admin_BrowseLog from "../views/admin/BrowseLog.vue"; 
import Admin_Banner from "../views/admin/Banner.vue";
import Admin_News from "../views/admin/News.vue";
import Admin_About from "../views/admin/About.vue";
import Admin_Member from "../views/admin/Member.vue"
import Admin_Admissions from "../views/admin/Admissions.vue";
import Admin_Curriculum from "../views/admin/Curriculum.vue";
import Admin_Research from "../views/admin/Research.vue";
import Admin_Forms from "../views/admin/Forms.vue";
import Admin_Links from "../views/admin/Links.vue";
import Admin_InServiceMaster from "../views/admin/InServiceMaster.vue"

import Admin_ForgetPwd from "../views/admin/ForgetPwd.vue"
import Admin_Logout from "../views/admin/Logout.vue";



//使用Router
Vue.use(VueRouter);

//設定路徑
const routes =[
    //前台網站設定區(中文)
    //前台主要頁面-首頁
    {
        path:"/",
        name:"Home",
        component: Home,
        meta:{
            stylesheet: "tw",
            title: '國立臺灣大學生物產業傳播暨發展學系',
            og_title: '國立臺灣大學生物產業傳播暨發展學系',
            og_description: '國立臺灣大學生物產業傳播暨發展學系致力於農產業行銷傳播與農鄉社會永續發展，歡迎探索本系的教學特色、研究成果、招生資訊與最新消息。',
        }
    },
    //前台主要頁面-網站導覽
    {
        path:"/Sitemap",
        name:"Sitemap",
        component:Sitemap,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-網站導覽',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-網站導覽',
            og_description: '瀏覽臺大生傳系網站導覽，快速找到系所介紹、系所成員、招生訊息、課程資訊、學術研究與常用表單。',
        }
    },
    //前台頁面-隱私權及資訊安全政策
    {
        path:"/Copyright",
        name:"Copyright",
        component:Copyright,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-隱私權及資訊安全政策',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-隱私權及資訊安全政策',
            og_description: '了解臺大生傳系網站的隱私權及資訊安全政策，查閱個人資料保護與網站使用相關說明。',
        }
    },
    //前台主要頁面-最新消息
    {
        path:"/News",
        name:"News",
        component:News,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-最新消息',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-最新消息',
            og_description: '掌握臺大生傳系最新消息，查看系所公告、學術活動、招生訊息與徵才資訊。',
        },
    },
    //前台主要頁面-最新消息-活動花絮
    {
        path:"/NewsAlbum",
        name:"NewsAlbum",
        component:NewsAlbum,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-最新消息-活動花絮',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-最新消息-活動花絮',
            og_description: '瀏覽臺大生傳系活動花絮，透過照片回顧系所活動、學術交流與校園生活的精彩時刻。',
        },
    },
    //前台主要頁面-最新消息-生傳影片
    {
        path:"/NewsVideo",
        name:"NewsVideo",
        component:NewsVideo,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-最新消息-生傳影片',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-最新消息-生傳影片',
            og_description: '觀看臺大生傳系影片，透過影音內容認識系所特色，探索活動紀錄與學習分享。',
        },
    },
    //前台主要頁面-關於生傳
    {
        path:"/About",
        name:"About",
        component:About,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-關於生傳',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-關於生傳',
            og_description: '認識臺大生傳系的發展歷程、教育目標與系所特色，了解農產業行銷傳播及農鄉社會永續發展的教學與研究方向。',
        },
    },
    //前台主要頁面-FAQ
    {
        path:"/FAQ",
        name:"FAQ",
        component:FAQ,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-相關法規',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-相關法規',
            og_description: '查閱臺大生傳系常見問題與解答，快速了解系所相關資訊及常用服務。',
        }
    },
    //前台主要頁面-系所成員
    {
        path:"/Member",
        name:"Member",
        component:Member,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-系所成員',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-系所成員',
            og_description: '認識臺大生傳系的師資與行政團隊，查閱成員介紹、專業領域及聯絡資訊。',
        },
    },
    //前台主要頁面-招生訊息
    {
        path:"/Admissions",
        name:"Admissions",
        component:Admissions,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-招生訊息',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-招生訊息',
            og_description: '查閱臺大生傳系招生訊息，了解入學管道、申請資訊與相關公告，規劃你的升學方向。',
        },
    },
    //前台主要頁面-課程資訊
    {
        path:"/Curriculum",
        name:"Curriculum",
        component:Curriculum,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-課程資訊',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-課程資訊',
            og_description: '探索臺大生傳系課程資訊，了解課程規劃與修課相關說明，安排你的學習與專業發展。',
        },
    },
    //前台主要頁面-學術研究
    {
        path:"/Research",
        name:"Research",
        component:Research,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-學術研究',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-學術研究',
            og_description: '探索臺大生傳系的學術研究，了解農產業行銷傳播、農鄉社會與永續發展等相關研究方向及成果。',
        },
    },
    //前台主要頁面-常用表單
    {
        path:"/Forms",
        name:"Forms",
        component:Forms,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-常用表單',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-常用表單',
            og_description: '查找臺大生傳系常用表單與相關文件，取得學習、申請及系務辦理所需資料。',
        },
    },
    //前台主要頁面-學術期刊
    {
        path:"/Journal",
        name:"Journal",
        component:Journal,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-學術期刊',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-學術期刊',
            og_description: '查閱臺大生傳系學術期刊相關資訊，探索生物產業傳播與發展領域的學術交流及研究資源。',
        },
    },
    //前台主要頁面-全文搜尋
    {
        path:"/Search",
        name:"Search",
        component:Search,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-全文搜尋',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-全文搜尋',
            og_description: '使用臺大生傳系網站全文搜尋，透過關鍵字查找公告、課程、招生與研究相關資訊。',
        },
    },
    //前台主要頁面-碩士在職專班
    {
        path:"/InServiceMaster",
        name:"InServiceMaster",
        component:InServiceMaster,
        meta:{
            stylesheet:"tw",
            title:'國立臺灣大學生物產業傳播暨發展學系-碩士在職專班',
            og_title: '國立臺灣大學生物產業傳播暨發展學系-碩士在職專班',
            og_description: '了解臺大生傳系碩士在職專班，查閱招生、課程與相關公告，探索在職進修及專業發展的機會。',
        },
    },
    //前台網站設定區(英文)
    //前台主要頁面-首頁
    {
        path:"/EN/",
        name:"Home_en",
        component: Home_en,
        meta:{
            stylesheet: "en",
            title: 'Department of Bio-Industry Communication and Development',
            og_title: 'Department of Bio-Industry Communication and Development',
            og_description: 'Explore teaching, research, admissions, and news from the Department of Bio-Industry Communication and Development at National Taiwan University, with a focus on agricultural communication and rural sustainability.',
        }
    },
    //前台主要頁面-網站導覽
    {
        path:"/EN/Sitemap",
        name:"Sitemap_en",
        component:Sitemap_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Sitemap',
            og_title: 'Department of Bio-Industry Communication and Development-Sitemap',
            og_description: 'Navigate the NTU BICD website to find information about the department, its members, admissions, curriculum, research, and forms.',
        }
    },
    //前台頁面-隱私權及資訊安全政策
    {
        path:"/EN/Copyright",
        name:"Copyright_en",
        component:Copyright_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Copyright',
            og_title: 'Department of Bio-Industry Communication and Development-Copyright',
            og_description: 'Read the privacy and information security policies for the NTU BICD website, including information on personal data protection and website use.',
        }
    },
    //前台主要頁面-最新消息
    {
        path:"/EN/News",
        name:"News_en",
        component:News_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-News',
            og_title: 'Department of Bio-Industry Communication and Development-News',
            og_description: 'Stay informed about NTU BICD announcements, academic events, admissions updates, and employment opportunities.',
        },
    },
    //前台主要頁面-最新消息-活動花絮
    {
        path:"/EN/NewsAlbum",
        name:"NewsAlbum_en",
        component:NewsAlbum_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-NewsAlbum',
            og_title: 'Department of Bio-Industry Communication and Development-NewsAlbum',
            og_description: 'Explore photos from NTU BICD events, academic exchanges, and campus life, and revisit memorable moments from department activities.',
        },
    },
    //前台主要頁面-最新消息-生傳影片
    {
        path:"/EN/NewsVideo",
        name:"NewsVideo_en",
        component:NewsVideo_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-NewsVideo',
            og_title: 'Department of Bio-Industry Communication and Development-NewsVideo',
            og_description: 'Discover NTU BICD through videos featuring department highlights, event recordings, and learning experiences.',
        },
    },
    //前台主要頁面-關於生傳
    {
        path:"/EN/About",
        name:"About_en",
        component:About_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-About',
            og_title: 'Department of Bio-Industry Communication and Development-About',
            og_description: 'Learn about the history, educational goals, and distinctive features of NTU BICD, including its focus on agricultural communication and sustainable rural development.',
        },
    },
    //前台主要頁面-FAQ
    {
        path:"/EN/FAQ",
        name:"FAQ_en",
        component:FAQ_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-FAQ',
            og_title: 'Department of Bio-Industry Communication and Development-FAQ',
            og_description: 'Find answers to frequently asked questions about NTU BICD and access useful information about the department and its services.',
        }
    },
    //前台主要頁面-系所成員
    {
        path:"/EN/Member",
        name:"Member_en",
        component:Member_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Member',
            og_title: 'Department of Bio-Industry Communication and Development-Member',
            og_description: 'Meet the faculty and administrative team at NTU BICD, and explore member profiles, areas of expertise, and contact information.',
        },
    },
    //前台主要頁面-招生訊息
    {
        path:"/EN/Admissions",
        name:"Admissions_en",
        component:Admissions_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Admissions',
            og_title: 'Department of Bio-Industry Communication and Development-Admissions',
            og_description: 'Explore admissions information for NTU BICD, including entry routes, application information, and announcements to help plan your studies.',
        },
    },
    //前台主要頁面-課程資訊
    {
        path:"/EN/Curriculum",
        name:"Curriculum_en",
        component:Curriculum_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Curriculum',
            og_title: 'Department of Bio-Industry Communication and Development-Curriculum',
            og_description: 'Explore the NTU BICD curriculum and course information to plan your studies and professional development.',
        },
    },
    //前台主要頁面-學術研究
    {
        path:"/EN/Research",
        name:"Research_en",
        component:Research_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Research',
            og_title: 'Department of Bio-Industry Communication and Development-Research',
            og_description: 'Discover research at NTU BICD in agricultural marketing and communication, rural society, and sustainable development.',
        },
    },
    //前台主要頁面-常用表單
    {
        path:"/EN/Forms",
        name:"Forms_en",
        component:Forms_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Forms',
            og_title: 'Department of Bio-Industry Communication and Development-Forms',
            og_description: 'Find commonly used forms and documents for academic applications and administrative procedures at NTU BICD.',
        },
    },
    //前台主要頁面-學術期刊
    {
        path:"/EN/Journal",
        name:"Journal_en",
        component:Journal_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Journal',
            og_title: 'Department of Bio-Industry Communication and Development-Journal',
            og_description: 'Explore academic journal information and scholarly resources related to bio-industry communication and development at NTU BICD.',
        },
    },
    //前台主要頁面-全文搜尋
    {
        path:"/EN/Search",
        name:"Search_en",
        component:Search_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-Search',
            og_title: 'Department of Bio-Industry Communication and Development-Search',
            og_description: 'Search the NTU BICD website by keyword to find announcements and information about courses, admissions, and research.',
        },
    },
    //前台主要頁面-碩士在職專班
    {
        path:"/EN/InServiceMaster",
        name:"InServiceMaster_en",
        component:InServiceMaster_en,
        meta:{
            stylesheet:"en",
            title:'Department of Bio-Industry Communication and Development-InServiceMaster',
            og_title: 'Department of Bio-Industry Communication and Development-InServiceMaster',
            og_description: 'Learn about the NTU BICD in-service master’s program, including admissions, course information, and announcements for working professionals seeking further study.',
        },
    },
    //後台網站設定區
    //後台主要頁面-登入頁面
    {
        path:'/ISY',
        name:'ISY',
        component: Admin_Login,
        meta:{
            stylesheet:"backside",
            title: '國立臺灣大學生物產業傳播暨發展學系'
        }
    },
    //後台主要頁面
    {
        path: "/backend",
        component:admin,
        meta:{
            stylesheet:"backside",
        },
        children:[
            //首頁
            {
                path: "/",
                name:"Admin_Home",
                component:Admin_Home,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //帳號管理
            {
                path: "/backend/Account",
                name:"Admin_Account",
                component:Admin_Account,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //群組及權限管理
            {
                path: "/backend/AccountGroup",
                name:"Admin_AccountGroup",
                component:Admin_AccountGroup,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //日誌檢視
            {
                path: "/backend/BrowseLog",
                name:"Admin_BrowseLog",
                component:Admin_BrowseLog,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //首頁管理-橫幅輪播
            {
                path: "/backend/Banner",
                name:"Admin_Banner",
                component:Admin_Banner,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //最新消息
            {
                path: "/backend/News",
                name:"Admin_News",
                component:Admin_News,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //關於生傳
            {
                path: "/backend/About",
                name:"Admin_About",
                component:Admin_About,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //系所成員
            {
                path: "/backend/Member",
                name:"Admin_Member",
                component:Admin_Member,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //招生訊息
            {
                path: "/backend/Admissions",
                name:"Admin_Admissions",
                component:Admin_Admissions,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //課程資訊
            {
                path: "/backend/Curriculum",
                name:"Admin_Curriculum",
                component:Admin_Curriculum,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //學術研究
            {
                path: "/backend/Research",
                name:"Admin_Research",
                component:Admin_Research,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //常用表單
            {
                path: "/backend/Forms",
                name:"Admin_Forms",
                component:Admin_Forms,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //友站連結
            {
                path: "/backend/Links",
                name:"Admin_Links",
                component:Admin_Links,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //碩士在職專班
            {
                path:"/backend/InServiceMaster",
                name:"Admin_InServiceMaster",
                component:Admin_InServiceMaster,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            //登出頁面
            {
                path: "/backend/Logout",
                name:"Admin_Logout",
                component:Admin_Logout,
                meta:{
                    stylesheet:"backside",
                    title: '國立臺灣大學生物產業傳播暨發展學系'
                }
            },
            
        ]
    },
    //忘記密碼
    {
        path: "/ForgetPwd",
        name:"Admin_ForgetPwd",
        component:Admin_ForgetPwd,
        meta:{
            stylesheet:"backside",
            title: '國立臺灣大學生物產業傳播暨發展學系'
        }
    },
    //若無上方目的路徑時，導向404錯誤頁面
    {
        path: "*",
        beforeEnter() {
            window.location.replace('/404.html');
        }

    }
]
const router = new VueRouter({
    mode: "history",
    routes,
});
router.beforeEach(MiddlewareStylesheet);

export default router;